import { Caregiver } from "./Caregiver.ts";
import {
  PersonalizedDiabetesProtocolApiDto,
  PersonalizedHypertensionProtocolApiDto,
} from "./ClinicalProtocol.ts";
import Department from "./Department.ts";
import { MedicationApiDto } from "./Medication";
import { UnreviewedDiabetesReadings, UnreviewedHypertensionReadings } from "./Patient";
import PatientStatus from "./PatientStatus";

export type PatientApiDto = {
  id: string;
  medicalRecordNumber: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  estimatedDateOfDelivery?: string;
  hypertension?: HypertensionFieldsApiDto;
  diabetes?: DiabetesFieldsApiDto;
  lastLiveInteractionTime?: string;
  clinicalTimeForCurrentMonthInSeconds: number;
};

export type HypertensionPatientApiDto = PatientApiDto & { hypertension: HypertensionFieldsApiDto };
export type DiabetesPatientApiDto = PatientApiDto & { diabetes: DiabetesFieldsApiDto };

export type HypertensionFieldsApiDto = {
  prescriptionId: string;
  diagnosis?: string;
  lastReviewTime?: string;
  firstReadingTime?: string;
  unreviewedReadings: UnreviewedHypertensionReadings;
  status: PatientStatus;
  personalizedClinicalProtocol: PersonalizedHypertensionProtocolApiDto;
  prescribingCaregiver: Caregiver;
  prescribingCaregiverDepartment?: Department;
  deliveryDate?: string;
  educationProvidedAt?: string;
  stickyNote: string;
};

export type DiabetesFieldsApiDto = {
  prescriptionId: string;
  diagnosis?: string;
  lastReviewTime?: string;
  firstReadingTime?: string;
  unreviewedReadings: UnreviewedDiabetesReadings;
  status: PatientStatus;
  personalizedClinicalProtocol: PersonalizedDiabetesProtocolApiDto;
  prescribingCaregiver: Caregiver;
  prescribingCaregiverDepartment?: Department;
  deliveryDate?: string;
  prescribedMedications: MedicationApiDto[];
  educationProvidedAt?: string;
  stickyNote: string;
};

export const hasHypertension = (patient: PatientApiDto): patient is HypertensionPatientApiDto =>
  !!patient.hypertension;

export const hasDiabetes = (patient: PatientApiDto): patient is DiabetesPatientApiDto =>
  !!patient.diabetes;
